export const getBaseStyledStripStyle = () => ({
  propertiesOverride: {},
  groups: {},
  properties: {
    brw: '0',
    brd: 'color_15',
    bg: 'color_11',
    rd: '0px',
    shd: '0.00px 5.00px 4px 0px rgba(0,0,0,0.6)',
    'alpha-brd': '1',
    'alpha-bg': '1',
    'boxShadowToggleOn-shd': 'false',
  },
  propertiesSource: {
    brw: 'value',
    brd: 'theme',
    bg: 'theme',
    rd: 'value',
    shd: 'value',
    'alpha-brd': 'value',
    'alpha-bg': 'value',
    'boxShadowToggleOn-shd': 'value',
  },
});
